import './unauthorized-component.scss';
import ADDLogo from '@svg/add-logo.svg?react';
import { useParams } from 'react-router-dom';
import { InternalErrorMessage } from './error-types/internal-error-message';
import { useEffect, useMemo } from 'react';
import { ExternalUnauthorizedMessage } from './error-types/external-unauthorized-message';
import { ExternalNoRolesMessage } from './error-types/external-no-roles-message';
import { ErrorType } from 'src/dtos/error-message.dto';
import { EventType } from 'src/dtos/analytics.dto';
import analyticsService from 'src/services/analytics.service';

export const UnauthorizedComponent = () => {
    const { errorType } = useParams();

    useEffect(() => {
        if (errorType === ErrorType.HALOB_NO_ROLES) {
            analyticsService.sendEvent(EventType.PageView, undefined, undefined, undefined, {
                pageName: 'unauthorizedAccess'
            });
        } else if (errorType === ErrorType.HALOB_NO_TRIPLETS) {
            analyticsService.sendEvent(EventType.PageView, undefined, undefined, undefined, {
                pageName: 'interestedInDynamicDefense'
            });
        }
    }, [errorType]);

    const errorBody = useMemo(() => {
        switch (errorType) {
            case ErrorType.AAD:
                return <InternalErrorMessage />;
            case ErrorType.HALOB_NO_TRIPLETS:
                return <ExternalUnauthorizedMessage />;
            case ErrorType.HALOB_NO_ROLES:
                return <ExternalNoRolesMessage />;
            default:
                return <></>;
        }
    }, [errorType]);

    return (
        errorType ? <div className="unauthorized-container">
                <div className="add-logo"><ADDLogo /></div>
            {errorBody}
        </div> : <></>
    );
};
